module.exports = __webpack_public_path__ + "img/bus-front.8ff41aa8.png";